import * as React from 'react';

import styles from './GameTile.module.scss';

interface GameTileProps {
  children: React.ReactNode;
}

const GameTile = (props: GameTileProps) => (
  <div className={styles.container} {...props}>
    {props.children}
  </div>
);

export default GameTile;
